import { __decorate } from 'tslib';
import { trigger, transition, animate, style } from '@angular/animations';
import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import { Default } from '@rogers/cdk/common/decorators';
import * as i1 from '@rogers/cdk/button';
import { ButtonModule } from '@rogers/cdk/button';
import * as i2 from '@rogers/cdk/icon';
import { IconModule } from '@rogers/cdk/icon';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

let uid = 0;
class AlertComponent {
    constructor() {
        this.show = true;
        this.state = 'visible';
        this.closeClick = new EventEmitter();
        this.id = this.id;
    }
    set id(id) {
        this._id = id || this.uniqueId;
    }
    get id() {
        return this._id;
    }
    ngOnInit() {
        if (this.autoHideTiming > 0) {
            setTimeout(() => this.close(), this.autoHideTiming);
        }
    }
    get uniqueId() {
        return `ds-alert-${uid++}`;
    }
    close() {
        this.state = 'hidden';
        this.closeClick.emit(this.id);
    }
    alertSlideUpDone(event) {
        if (event.toState === 'hidden') {
            this.show = false;
        }
    }
}
AlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
AlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.12", type: AlertComponent, selector: "ds-alert", inputs: { autoHideTiming: "autoHideTiming", closeLabel: "closeLabel", disableBorder: "disableBorder", id: "id", showCloseButton: "showCloseButton", variant: "variant" }, outputs: { closeClick: "closeClick" }, host: { properties: { "attr.id": "id", "class.d-block": "true" } }, ngImport: i0, template: "<div\n  *ngIf=\"show\"\n  [@alertSlideUp]=\"state\"\n  (@alertSlideUp.done)=\"alertSlideUpDone($event)\"\n  class=\"ds-alert {{ 'ds-bgcolor-light-' + variant }}\"\n  [ngClass]=\"disableBorder ? '' : 'ds-borders ds-brcolor-' + variant\"\n>\n  <div\n    class=\"container position-relative py-16\"\n    [ngClass]=\"{\n      'pr-72 pr-md-80': showCloseButton\n    }\"\n  >\n    <ng-content></ng-content>\n\n    <button\n      *ngIf=\"showCloseButton\"\n      ds-button\n      variant=\"icon\"\n      class=\"position-absolute top-4 right-16\"\n      [attr.title]=\"closeLabel\"\n      [transparent]=\"true\"\n      (click)=\"close()\"\n    >\n      <ds-icon name=\"close\"></ds-icon>\n    </button>\n  </div>\n</div>\n", components: [{ type: i1.ButtonComponent, selector: "button[ds-button], a[ds-button]", inputs: ["variant", "size", "alignIcon", "img", "transparent", "disabled", "tabIndex", "a11yDescription"] }, { type: i2.IconComponent, selector: "ds-icon", inputs: ["name", "color", "caption", "ariaHidden", "size"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], animations: [
        trigger('alertSlideUp', [
            transition('* => hidden', [animate('200ms', style({ opacity: '0' }))]),
        ]),
    ], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Default(false)
], AlertComponent.prototype, "disableBorder", void 0);
__decorate([
    Default(true)
], AlertComponent.prototype, "showCloseButton", void 0);
__decorate([
    Default('warning')
], AlertComponent.prototype, "variant", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ds-alert', encapsulation: ViewEncapsulation.None, host: {
                        '[attr.id]': 'id',
                        '[class.d-block]': 'true',
                    }, animations: [
                        trigger('alertSlideUp', [
                            transition('* => hidden', [animate('200ms', style({ opacity: '0' }))]),
                        ]),
                    ], template: "<div\n  *ngIf=\"show\"\n  [@alertSlideUp]=\"state\"\n  (@alertSlideUp.done)=\"alertSlideUpDone($event)\"\n  class=\"ds-alert {{ 'ds-bgcolor-light-' + variant }}\"\n  [ngClass]=\"disableBorder ? '' : 'ds-borders ds-brcolor-' + variant\"\n>\n  <div\n    class=\"container position-relative py-16\"\n    [ngClass]=\"{\n      'pr-72 pr-md-80': showCloseButton\n    }\"\n  >\n    <ng-content></ng-content>\n\n    <button\n      *ngIf=\"showCloseButton\"\n      ds-button\n      variant=\"icon\"\n      class=\"position-absolute top-4 right-16\"\n      [attr.title]=\"closeLabel\"\n      [transparent]=\"true\"\n      (click)=\"close()\"\n    >\n      <ds-icon name=\"close\"></ds-icon>\n    </button>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return []; }, propDecorators: { autoHideTiming: [{
                type: Input
            }], closeLabel: [{
                type: Input
            }], disableBorder: [{
                type: Input
            }], id: [{
                type: Input
            }], showCloseButton: [{
                type: Input
            }], variant: [{
                type: Input
            }], closeClick: [{
                type: Output
            }] } });

class AlertModule {
}
AlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertModule, declarations: [AlertComponent], imports: [CommonModule, ButtonModule, IconModule], exports: [AlertComponent] });
AlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertModule, imports: [[CommonModule, ButtonModule, IconModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.12", ngImport: i0, type: AlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AlertComponent],
                    imports: [CommonModule, ButtonModule, IconModule],
                    exports: [AlertComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModule };
